<script setup lang="ts">
import type { SwipeInstance, SearchInstance } from 'vant'
import news from './components/news.vue'
import newslist from './components/newslist.vue'
import stocklist from './components/stocklist.vue'

definePage({
  name: 'add-list',
  meta: {
    title: '添加自选',
  },
})

const router = useRouter()
const route = useRoute();

const id = route.query.id ? Number(route.query.id) : 0;
const back = () => {
  router.back()
}

const active = ref(0)

const swipeRef = ref<SwipeInstance | null>(null);
const activeTab = ref(0);
const tabs = ['热度榜', '扫货砸盘榜'];

const allLists = ref([
  {
    title: '港股热度榜',
    updateTime: '01/02 16:31',
    data: [
      { name: '壁仞科技', change: 75.82, price: 34.460 },
      { name: '天齐锂业', change: 2.55, price: 52.350 },
      { name: '再鼎医药', change: -0.51, price: 13.580 },
      { name: '再鼎医药', change: 4.34, price: 149.00 },
      { name: '再鼎医药', change: 20.95, price: 16.220 }
    ]
  },
  {
    title: '扫货砸盘榜',
    updateTime: '01/02 16:40',
    data: [
      { name: '腾讯控股', change: 1.22, price: 380.40 },
      { name: '阿里巴巴', change: -2.15, price: 82.35 },
      { name: '美团-W', change: 5.31, price: 113.50 },
      { name: '京东集团', change: -1.34, price: 149.00 },
      { name: '小米集团', change: 0.95, price: 16.22 }
    ]
  }
]);

const onSwipeChange = (index: number) => {
  activeTab.value = index;
};

const onTabClick = (index: number) => {
  activeTab.value = index;
  swipeRef.value?.swipeTo(index);
};

const searchValue = ref('');

const onKeyClick = (val: string) => {
  searchValue.value += val;
};

// 处理功能键
const onAction = (type: 'clear' | 'back' | 'confirm') => {
  if (type === 'clear') {
    searchValue.value = '';
  } else if (type === 'back') {
    searchValue.value = searchValue.value.slice(0, -1);
  } else if (type === 'confirm') {
    console.log('提交搜索:', searchValue.value);
  }
};

const inputRef = ref<SearchInstance | null>(null)

const showBoard = ref(true)

const triggerKeyboard = () => {
  if (inputRef.value) {
    inputRef.value.focus();
    showBoard.value = false
  }
};

const placeholder = ref('股票代码/全拼/首字母')
const changeTab = (index: number) => {
  if (index === 1) {
    placeholder.value = '搜素资讯关键字'
  } else {
    placeholder.value = '股票代码/全拼/首字母'
    showBoard.value = true
  }
  searchValue.value = ''
}
</script>
<template>
  <FmPageLayout navbar :search="false">
    <template #navbar>
      <div class="flex justify-between items-center">
        <div class="search flex-1">
          <van-search :placeholder="placeholder" background="var(--background)" v-model="searchValue" ref="inputRef" >
            <template #left-icon>
            <img src="@/assets/images/search.png" alt="" width="14px" class="m-r-9px">
          </template>
          </van-search>
        </div>
        <div class="text-16px color-[#fff] m-r-14px" @click="back"> 取消</div>
      </div>
    </template>
    <div class="stock-page">
      <van-tabs v-model:active="active" color="#1989fa" background="#F1F2F7" @change="changeTab">
        <van-tab title="股票">
          <stocklist v-if="searchValue" v-model:id="id" />
          <div class="rank-card bg-[#fff]" v-else>
            <div class="header-tabs">
              <div v-for="(tab, index) in tabs" :key="index" :class="['tab-item', { active: activeTab === index }]"
                @click="onTabClick(index)">
                {{ tab }}
                <div v-if="activeTab === index" class="tab-line"></div>
              </div>
            </div>

            <van-swipe class="my-swipe" ref="swipeRef" :loop="false" :show-indicators="false" @change="onSwipeChange">
              <van-swipe-item v-for="(list, listIdx) in allLists" :key="listIdx">
                <div class="stock-card">
                  <div class="card-header">
                    <div class="header-left">
                      <van-tag type="danger" round class="tag-icon">港</van-tag>
                      <span class="title">{{ list.title }}</span>
                    </div>
                    <div class="header-right">
                      <span>更新:{{ list.updateTime }}</span>
                      <van-icon name="arrow" />
                    </div>
                  </div>

                  <div class="stock-list">
                    <div v-for="(item, index) in list.data" :key="index" class="stock-row">
                      <div class="rank-box">
                        <div v-if="index < 3" :class="['rank-tag', `top-${index + 1}`]">
                          TOP{{ index + 1 }}
                        </div>
                        <div v-else class="rank-num">{{ index + 1 }}</div>
                      </div>
                      <div class="stock-name">{{ item.name }}</div>
                      <div :class="['stock-percent', item.change >= 0 ? 'up' : 'down']">
                        {{ item.change >= 0 ? '+' : '' }}{{ item.change }}%
                      </div>
                      <div :class="['stock-price', item.change >= 0 ? 'up' : 'down']">
                        {{ item.price }}
                      </div>
                    </div>
                  </div>
                </div>
              </van-swipe-item>
            </van-swipe>

            <div class="custom-indicator">
              <div v-for="(_, index) in allLists" :key="index" :class="['dot', { active: activeTab === index }]"></div>
            </div>
          </div>
          <div class="custom-keyboard" v-if="showBoard">
            <div class="color-[#3C78FF] bg-[#FFEFE5] text-center p-9px text-12px">
              港股行情至少延时15分钟，购买港股行情
            </div>
            <div class="search-bar">
              <van-icon name="audio" /> 按住 说出要找的股票
            </div>
            <div class="keyboard-grid">
              <div class="kb-left bg-[#f2f3f5]">
                <div v-for="n in ['600', '601', '000', '002', '300']" :key="n" class="kb-key-gray"  @click="onKeyClick(n)">
                  {{ n }}
                </div>
              </div>
              <div class="kb-main">
                <div v-for="n in 9" :key="n" class="kb-key" @click="onKeyClick(n.toString())">{{ n }}</div>
                <div class="kb-key bg-[#f2f3f5]" @click="onKeyClick('ABC')">ABC</div>
                <div class="kb-key " @click="onKeyClick('0')">0</div>
                <div class="kb-key confirm-btn text-20px">确认</div>
              </div>
              <div class="kb-right bg-[#f2f3f5]">
                <div class="kb-key-r icon-key " @click="onAction('back')">
                  <van-icon name="delete-o"/>
                </div>
                <div class="kb-key-r text-20px " @click="onAction('clear')">清空</div>
                <div class="kb-key-r " @click="triggerKeyboard"><van-icon name="points" /></div>
              </div>
            </div>
          </div>
        </van-tab>
        <van-tab title="资讯">
          <newslist v-if="searchValue" />
          <news v-else />
        </van-tab>
      </van-tabs>
    </div>
  </FmPageLayout>
</template>
<style lang="scss">
.search {
  .van-search__content {
    border-radius: 8px;
  }
}

.stock-page {
  // min-height: 100vh;
  // padding-bottom: 200px;
  background: #f2f5f9;
}

.rank-card {
  padding: 12px;
  // margin: 12px;
  // background: #eef5ff;
  border-radius: 8px;
}

.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
  font-size: 13px;
}

.stock-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
  font-size: 14px;
}

.rank-num {
  padding: 4px;
  padding-left: 8px;
  font-size: 10px;
  font-style: italic;
  color: #666;
  // background: #ddd;
  // border-radius: 2px;
  text-align: center;
}

.top-1 {
  color: #fff;
  background: #ffd700;
}

.red {
  color: #ee0a24;
}

.green {
  color: #07c160;
}

/* 键盘部分 */
.custom-keyboard {
  position: fixed;
  bottom: 0;
  width: 100%;
  background: #fff;
  border-top: 1px solid #ebedf0;
}

.search-bar {
  padding: 10px;
  font-size: 14px;
  color: #666;
  text-align: center;
  background: #ddd;
}

.keyboard-grid {
  display: flex;
}

.kb-left {
  width: 20%;
}

.kb-main {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  width: 60%;
}

.kb-right {
  width: 20%;
}

.kb-key,
.kb-key-gray,
.kb-key-r {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  border: 0.5px solid #ebedf0;
}

.kb-key,
.kb-key-r {
  height: calc(250px / 4);
}

// .kb-key-r {
//   height: calc(250px / 4);
// }

.confirm-btn {
  grid-column: span 1;
  background: #f2f3f5;
}

.page-container {
  padding: 12px;
  background-color: #f8f9fc;
}

/* 顶部 Tab 样式 */
.header-tabs {
  display: flex;
  gap: 20px;
  padding: 0 10px 15px;
}

.tab-item {
  position: relative;
  font-size: 16px;
  font-weight: 500;
  color: #999;
}

.tab-item.active {
  font-weight: bold;
  color: #333;
}

.tab-line {
  position: absolute;
  bottom: -6px;
  left: 50%;
  width: 15px;
  height: 3px;
  background-color: #1989fa;
  border-radius: 2px;
  transform: translateX(-50%);
}

/* 卡片样式 */
.stock-card {
  padding: 12px;
  margin: 0 4px;
  background: linear-gradient(180deg, #eef5ff 0%, #fff 50%);
  border-radius: 12px;

  /* 防止滑动时卡片边缘紧贴 */
  box-shadow: 0 4px 12px rgb(0 0 0 / 3%);
}

// .card-header {
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   margin-bottom: 15px;
// }

.header-left {
  display: flex;
  align-items: center;
  font-weight: bold;
}

.tag-icon {
  margin-right: 6px;
  scale: 0.8;
}

.header-right {
  font-size: 12px;
  color: #999;
}

/* 列表行样式 */
.stock-row {
  display: flex;
  align-items: center;
  height: 48px;
  border-bottom: 1px solid #f2f5f9;
}

.rank-box {
  // width: 50px;
  margin-right: 8px;
}

.rank-tag {
  padding: 4px;
  font-size: 12px;
  color: #fff;
  text-align: center;
  border-radius: 1px;
}

.top-2 {
  background: #b8c4d9;
}

.top-3 {
  background: #e3c09b;
}

// .rank-num {
//   padding-left: 8px;
//   font-style: italic;
//   color: #666;
// }

.stock-name {
  flex: 1;
  font-size: 14px;
  color: #333;
}

.stock-percent,
.stock-price {
  width: 75px;
  font-weight: 500;
  text-align: right;
}

.up {
  color: #f5222d;
}

.down {
  color: #52c41a;
}

/* 指示器样式 */
.custom-indicator {
  display: flex;
  justify-content: center;
  margin-top: 15px;
}

.dot {
  width: 6px;
  height: 6px;
  margin: 0 3px;
  background-color: #e0e0e0;
  border-radius: 50%;
  transition: all 0.3s;
}

.dot.active {
  width: 12px;
  background-color: #1989fa;
  border-radius: 3px;
}
</style>
